import { PriceDetailsFragment, RatePlanFragment } from 'src/common/__generated__/api/types';

import RatePlan = RatePlanFragment.Fragment;
import Offer = PriceDetailsFragment.Fragment;

export const adaptFeeMessagesForRatePlan = (ratePlan: RatePlan) => ratePlan.priceDetails && ratePlan.priceDetails?.[0]?.feeMessages;

export const adaptFeeMessagesForPaymentPlan = (offer: Offer) => offer.feeMessages;
